import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE = {
  name: 'Hariwood',
  url: 'https://hariwood.in',
  defaultImage: 'https://hariwood.in/folk_banner_hd.webp',
  defaultDescription:
    'Hariwood is the #1 platform to discover Haryanvi songs, artists, singers, DJs and folk music. Stream new Haryanvi hits and explore Haryana\'s music culture.',
  twitter: '@hariwood',
};

/**
 * SEO component — drop into any page to control head tags.
 *
 * Usage:
 *   <SEO title="Explore" description="..." path="/explore" />
 *   <SEO title={artist.name} image={artist.image} path={`/artists/${artist._id}`} jsonLd={...} />
 */
export default function SEO({
  title,
  description,
  image,
  path = '/',
  type = 'website',
  jsonLd,
  noindex = false,
}) {
  const fullTitle = title ? `${title} | ${SITE.name}` : `${SITE.name} - Haryanvi Songs, Artists & Music Platform`;
  const metaDescription = description || SITE.defaultDescription;
  const canonical = `${SITE.url}${path}`;
  const ogImage = image || SITE.defaultImage;

  return (
    <Helmet prioritizeSeoTags>
      <html lang="hi-IN" />
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      <link rel="canonical" href={canonical} />

      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE.name} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content="hi_IN" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={ogImage} />

      {/* Structured data */}
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
}
